import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import axios from '../../axios'
import Alert from 'react-s-alert'
import CustomModal from '../../components/CustomModal.js'
import Paging from '../../components/Paging'
import qs from 'qs'
import queryString from 'query-string'
import fp from 'lodash/fp'
import DropdownView from './DropdownView'
import XLSX from 'xlsx'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import FormDropdown from "../../components/FormDropdown";
import ModalHelp from "../../components/ModalHelp";

const normalizeLevelName = (str) => {
    return fp.startCase(str.replace("_", " "))
}

// const yourDate = new Date()
const NewDateStart  = moment().format('YYYY-MM-DD')
const NewDateEnd    = moment().add(1, 'days').format('YYYY-MM-DD')

class Online extends Component {

    constructor() {
        super();
        this.state = {
            pageCount    : 0,
            currentPage  : 0,
            user_id      : 0,
            user_level     : "",
            tutorial: '',
            isModalHelpShow  : false,
            listOnline:[],
            user_online:"",
            isButtonLoading: false,
            isLoading    : true,
        }
        this.handleChange               = this.handleChange.bind(this)
        this.handlePageClick            = this.handlePageClick.bind(this)
        this.toggleModalHelp                = this.toggleModalHelp.bind(this)

    }
    toggleModalHelp() {

        this.setState({tutorial : 'https://www.youtube.com/embed/zOcvh_vsnFU'})

        this.setState({ isModalHelpShow: ! this.state.isModalHelpShow })
    }

    handleChange(event) {
        
        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })        
    }

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({currentPage: selected}, () => {
            this.loadData();
            this.loadExport();
        });
    };




    loadData() {

        this.setState({ isLoading: true });

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            user_level : this.state.user_level
        })

        axios({
            method: "post",
            url: "/reportonline?"+params
        })
            .then(response => {
                const result = response.data;

                if (result.success === true) {
                    this.setState({
                        isLoading: false,

                        listOnline: result.data.listOnline,

                    });
                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }


    componentDidMount() {
         this.loadData();

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.location.search !== this.props.location.search || 
            prevState.user_level !== this.state.user_level) {
            this.loadData()

        }
    }

    render () {

        
        return (                    
            <div className="col-sm-12">

                <ModalHelp
                    isShow={this.state.isModalHelpShow}
                    toggleModal={this.toggleModalHelp}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Tutorial Penggunaan Fitur"
                    modalBodyText={this.state.tutorial}
                    modalSubmitText="Ya" />

                <div className="card">
                    <div className="card-header">
                        User Online
                        <button
                            type="button"
                            title='Tutorial'
                            className="btn btn-danger btn-sm"
                            style={{ float: 'right'}}
                            onClick={() => {
                                this.toggleModalHelp();
                                // this.setState({ tutorial: levelName});
                            }}
                        >
                            <i className="fa fa-question-circle"s></i>
                        </button>
                    </div>
                    <br></br>
                    <div className="col-md-8">
                        <DropdownView
                            handleChange={this.handleChange}
                            stateName="user_level"
                            items={[
                                { key: "siswa", value: "Siswa" },
                                { key: "guru", value: "Guru" },
                                { key: "wali", value: "Wali" },
                            ]}
                            value={this.state.user_level}
                        />
                    </div>
                        
                        {
                            this.state.isLoading ? "Memuat Data..." : (
                                this.state.listOnline.length === 0 ? "Data Kosong..." : (
                                    <div>
                                        <table className="table table-striped animated fadeIn">
                                            <thead>
                                                <tr>
                                                    <th>Nama Lengkap</th>
                                                    <th>Nama Device</th>
                                                    <th>Level</th>
                                                    </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.listOnline.map((item) => {

                                                        return (
                                                            <tr key={item.user_id}>
                                                                <td>{item.user_nama}</td>
                                                                <td>{item.user_device_name}</td>
                                                                <td>{item.user_level}</td>


                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>

                                        <Paging 
                                            handlePageClick={this.handlePageClick}
                                            pageCount={this.state.pageCount}
                                            currentPage={this.state.currentPage}
                                        />
                                    </div>                                        
                                )
                            )
                        }
                    </div>
                </div>

        )
    }
}

export default Online;


// WEBPACK FOOTER //
// ./src/views/Monitoring/Online.js